import React, {Component} from 'react'
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs'
import ChangePassword from './changepassword/changepassword'
import Payment from './history/payment'
import UsedCredit from './history/usedcredit'
import PersonalData from './personaldata'
import api from '../../source/api'
import PricingData from "./pricingdata";
import BillingData from "./billingdata/billingdata";

export default class Profile extends Component {

    constructor(props) {
        super(props)
        this.state = {
            profile: {},
            billing: {},
            payments: {},
            usedcredits: {},
            balanceInfo: {}
        }
    }

    /**
     * @deprecated To be deprecated in React v17.
     * todo: Use componentDidMount instead.
     */
    componentWillMount = () => {
        api.get({url: 'user/profile/init', data: {}}, true).then((response) => {
            if (response.status === 200) {
                this.setState({
                    profile: response.data.profile,
                    billing: response.data.billing,
                    usedcredits: response.data.usedcredits,
                    payments: response.data.payments,
                    balanceInfo: response.data.balanceInfo,
                })
            }
        }).catch((err) => {

        })
    }

    render() {
        return (
            <section id='profile'>
                <div className="container">
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <h1 className=''>Felhasználó profil</h1>
                            <Tabs>
                                <TabList>
                                    {/*<Tab>Könyvelőiroda</Tab>*/}
                                    <Tab>Személyes adatok</Tab>
                                    <Tab>Számlázási adatok</Tab>
                                    <Tab>Egyenleg</Tab>
                                    <Tab>Egyenleg felhasználások</Tab>
                                    <Tab>Befizetések</Tab>
                                    <Tab>Jelszó csere</Tab>
                                </TabList>

                                <TabPanel>
                                    <PersonalData profile={this.state.profile}/>
                                </TabPanel>
                                <TabPanel>
                                    <BillingData billing={this.state.billing}/>
                                </TabPanel>
                                <TabPanel>
                                  <PricingData profile={this.state.profile} balanceInfo={this.state.balanceInfo} />
                                </TabPanel>
                                <TabPanel>
                                    <UsedCredit usedcredits={this.state.usedcredits}/>
                                </TabPanel>
                                <TabPanel>
                                    <Payment payments={this.state.payments}/>
                                </TabPanel>
                                <TabPanel>
                                    <ChangePassword/>
                                </TabPanel>
                            </Tabs>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/profile/profile.js